var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ElementRef, AfterContentInit, OnInit, ChangeDetectorRef, EventEmitter } from '@angular/core';
import * as calcite from 'calcite-web';
import { DrawToolComponent } from '../draw-tool/draw-tool.component';
import { SearchTipsComponent } from '../search-tips/search-tips.component';
import { Router } from '@angular/router';
import { environmentMIQ } from 'src/environment-miq';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
export class NavMenuComponent {
    constructor(router, changeDectRef, httpClient) {
        this.router = router;
        this.changeDectRef = changeDectRef;
        this.httpClient = httpClient;
        this.isLoggedIn = false;
        this._isInternal = true;
        this.onLogIn = new EventEmitter();
        this.mapCatalogHeightMax = 1024;
        this.mapCatalogWidthMax = 768;
        this.maxHeight = 768;
        this.drawToolWidth = 500;
        this.drawToolTop = 100;
        this.markerSymbol = {
            type: 'simple-marker',
            style: 'circle',
            outline: {
                width: 2,
                color: 'red'
            }
        };
        this.pdauthUserId = '';
        this.pdauthToken = [];
        this.pdauthURL = environmentMIQ.pdauthURL;
        this.userName = 'no one';
        this.selectedDistrictId = 0;
        this.appendedWarning = false;
        this._showOverview = false;
        this.onResetPress = new EventEmitter();
        this.onResetConfirm = new EventEmitter();
        this.onShowOverview = new EventEmitter();
        this.onMapOpened = new EventEmitter();
        this.userSettingsChange = new EventEmitter();
        this.disableIdentify = new EventEmitter();
        this.openShareMap = new EventEmitter();
        this.unreadMessages = 0;
    }
    get isInternal() {
        return this._isInternal;
    }
    get showOverview() {
        return this._showOverview;
    }
    set showOverview(val) {
        this._showOverview = val;
        this.onShowOverview.emit(this._showOverview);
    }
    get titleAddition() {
        return environmentMIQ.titleAddition;
    }
    ngOnInit() {
        this.searchRef.nativeElement.filterLayersBeforeAdd = true;
        this.searchRef.nativeElement.enableNotificationSearch = true;
        this.authRef.nativeElement.user.subscribe(user => {
            if (user) {
                this.userName = user.fullName;
                this.isLoggedIn = true;
                this.onLogIn.emit(true);
                this.disclaimerWindowRef.nativeElement.close();
            }
            else {
                this.userName = 'no one';
                this.isLoggedIn = false;
                this.onLogIn.emit(false);
            }
            this.showOrHideDisclaimer();
            this.changeDectRef.detectChanges(); // Needed because AOI log in button doesn't update on actual login action for some reason
        });
        this.authRef.nativeElement.permissions.subscribe(permissions => {
            this.userPermissions = permissions;
            this.showOrHideDisclaimer();
        });
        this.authRef.nativeElement.isOnInternalNetwork.subscribe(internal => {
            this._isInternal = internal;
        });
        this.mapCatalogWindowRef.nativeElement.addEventListener('openChange', open => {
            this.mapCatalogRef.nativeElement.active = open.detail;
        });
        this.mapCatalogRef.nativeElement.addEventListener('openmergemap', event => {
            this.mapCatalogWindowRef.nativeElement.close();
            this.mapMergeWindowRef.nativeElement.open();
            this.mapMergeRef.nativeElement.map = event.detail;
        });
        this.mapCatalogRef.nativeElement.addEventListener('opensharemap', maps => {
            this.mapCatalogWindowRef.nativeElement.close();
            this.openShareMap.emit(maps.detail);
        });
        this.mapMergeRef.nativeElement.addEventListener('ondone', event => {
            this.mapMergeWindowRef.nativeElement.close();
            if (event.detail) {
                this.mapOpened(event);
            }
        });
        this.mapMergeRef.nativeElement.addEventListener('oncancel', event => {
            this.mapMergeWindowRef.nativeElement.close();
        });
        this.drawToolWindow.nativeElement.addEventListener('openChange', open => {
            open.detail ? this.drawTool.onOpen() : this.drawTool.onClose();
            this.deactivateIdentifyWhenOpen({ key: 'draw', disable: open.detail });
        });
        this.routingWindowRef.nativeElement.addEventListener('openChange', open => {
            this.routingRef.nativeElement.active = open.detail;
            this.deactivateIdentifyWhenOpen({ key: 'route', disable: open.detail });
        });
        this.bookmarksWindowRef.nativeElement.addEventListener('openChange', open => {
            this.bookmarksRef.nativeElement.active = open.detail;
        });
        this.userSettingsWindowRef.nativeElement.addEventListener('openChange', open => {
            this.userSettingsRef.nativeElement.active = open.detail;
        });
        this.userSettingsRef.nativeElement.addEventListener('activeChange', event => {
            if (event.detail === false) {
                this.userSettingsWindowRef.nativeElement.close();
            }
        });
        this.userSettingsRef.nativeElement.addEventListener('settingsChange', event => {
            this.userSettingsChange.emit(event.detail);
        });
        this.videoLogWindowRef.nativeElement.addEventListener('openChange', open => {
            this.videoLogRef.nativeElement.active = open.detail;
        });
        this.videoLogWindowRef.nativeElement.addEventListener('stateChange', (state) => {
            var videoLogService = this.videoLogControllerRef.nativeElement.VideoLogService;
            if (state.detail === 'maximized' && !videoLogService.isFullSize) {
                videoLogService.toggleFullsizeImages();
            }
        });
        this.irowWindowRef.nativeElement.addEventListener('openChange', open => {
            this.irowRef.nativeElement.active = open.detail;
        });
        this.openVLSubscription = this.openVL.subscribe((CRS) => {
            this.videoLogWindowRef.nativeElement.open();
            // wait for videolog to load it previous spot, then overwrite it with our parameters.
            setTimeout(() => {
                this.videoLogRef.nativeElement.setCrs(CRS);
            }, 750);
        });
        this.openSVSubscription = this.openSV.subscribe((CRS) => {
            this.streetViewWindowRef.nativeElement.open();
            this.streetViewRef.nativeElement.setRms(CRS);
        });
        this.calloutToolWindowRef.nativeElement.addEventListener('openChange', open => {
            this.calloutToolRef.nativeElement.active = open.detail;
            this.deactivateIdentifyWhenOpen({ key: 'callout', disable: open.detail });
        });
        this.isleWindowRef.nativeElement.addEventListener('openChange', open => {
            this.isleRef.nativeElement.active = open.detail;
        });
        this.petlWindowRef.nativeElement.addEventListener('openChange', open => {
            this.petlRef.nativeElement.active = open.detail;
            if (open.detail) {
                this.petlRef.nativeElement.initialize();
            }
        });
        this.measureToolsWindowRef.nativeElement.addEventListener('openChange', open => {
            this.deactivateIdentifyWhenOpen({ key: 'measure', disable: open.detail });
            if (!open.detail) {
                this.distanceRef.nativeElement.active = false;
                this.areaRef.nativeElement.active = false;
                this.coordinatesRef.nativeElement.active = false;
            }
        });
        this.systemMessagesWindowRef.nativeElement.addEventListener('openChange', open => {
            this.systemMessagesRef.nativeElement.active = open.detail;
        });
        this.mapRef.ready.then(() => {
            this.mapRef.mapView.watch('scale', (newScale) => {
                setTimeout(() => {
                    this.videoLogRef.nativeElement.buffer = newScale / 100;
                    this.isleRef.nativeElement.tolerance = newScale / 100;
                    this.irowRef.nativeElement.tolerance = newScale / 100;
                }, 50);
            });
        });
        this.systemMessagesRef.nativeElement.addEventListener('unreadMessages', unreadMessages => {
            this.unreadMessages = unreadMessages.detail;
        });
        this.systemMessagesRef.nativeElement.addEventListener('adminMode', adminMode => {
            if (adminMode.detail) {
                this.systemMessagesWindowRef.nativeElement.width = 980;
            }
            else {
                this.systemMessagesWindowRef.nativeElement.width = 700;
            }
        });
        this.streetViewWindowRef.nativeElement.addEventListener('openChange', open => {
            this.streetViewRef.nativeElement.active = open.detail;
        });
        this.streetViewRef.nativeElement.addEventListener('positionChange', (position) => {
            this.latLongSelectRef.nativeElement.setAttribute('lat', position.detail.latitude);
            this.latLongSelectRef.nativeElement.setAttribute('long', position.detail.longitude);
            this.rmsSelectRef.nativeElement.position = position.detail;
        });
        this.latLongSelectRef.nativeElement.addEventListener('latChange', (lat) => {
            this.streetViewRef.nativeElement.setAttribute('lat', lat.detail);
        });
        this.latLongSelectRef.nativeElement.addEventListener('longChange', (long) => {
            this.streetViewRef.nativeElement.setAttribute('long', long.detail);
        });
        this.rmsSelectRef.nativeElement.addEventListener('rmsChange', (rms) => {
            this.streetViewRef.nativeElement.setRms(rms.detail);
        });
        // Trigger loading user settings
        const userSettingsChangeTempListener = (settings) => {
            this.userSettingsRef.nativeElement.removeEventListener('settingsChange', userSettingsChangeTempListener);
            this.userSettingsRef.nativeElement.active = false;
        };
        this.userSettingsRef.nativeElement.addEventListener('settingsChange', userSettingsChangeTempListener);
        this.userSettingsRef.nativeElement.active = true;
        this.layerCatalogRef.nativeElement.addEventListener('openShareLayers', (layerId) => {
            //close layerCatalog and open share layers
            this.layerCatalogWindowRef.nativeElement.close();
            this.openShareLayerComponent(layerId.detail);
        });
        this.openShareLayerSubscription = this.openShareLayer.subscribe((layerId) => {
            this.openShareLayerComponent(layerId);
        });
        this.shareLayerRef.nativeElement.addEventListener('onclose', () => {
            this.shareLayerWindowRef.nativeElement.close();
        });
        this.shareLayerWindowRef.nativeElement.addEventListener('openChange', (open) => {
            if (!open.detail) {
                this.shareLayerRef.nativeElement.userIds = [];
                this.shareLayerRef.nativeElement.recipients = [];
                this.shareLayerRef.nativeElement.alreadySharedNames = [];
                this.shareLayerWindowRef.nativeElement.active = false;
            }
        });
        this.layerCatalogRef.nativeElement.addEventListener('openUnshareLayers', (layerId) => {
            //close layerCatalog and open unshare layers
            this.layerCatalogWindowRef.nativeElement.close();
            this.unshareLayerRef.nativeElement.layerId = null;
            this.unshareLayerRef.nativeElement.layerId = layerId.detail;
            this.unshareLayerWindowRef.nativeElement.open();
        });
        this.unshareLayerRef.nativeElement.addEventListener('onclose', () => {
            this.unshareLayerRef.nativeElement.layerId = null;
            this.unshareLayerWindowRef.nativeElement.close();
        });
        this.generateCcList();
    }
    get loggedIn() {
        return this.isLoggedIn;
    }
    get rms() {
        return (this.mapRef && this.mapRef.map && this.mapRef.map.mapcoreProps && this.mapRef.map.mapcoreProps.rms);
    }
    get rmsSnippet() {
        if (this.rms) {
            const rms = this.rms;
            const parts = [rms.countyCode, rms.stateRoute, rms.segmentBegin].filter(x => x);
            return `: ${parts.join(' | ')}`;
        }
        return '';
    }
    openResetMap() {
        this.onResetPress.emit();
        this.resetMapWindowRef.nativeElement.open();
        this.bookmarksWindowRef.nativeElement.close();
        this.userSettingsWindowRef.nativeElement.close();
        this.streetViewWindowRef.nativeElement.close();
        this.videoLogWindowRef.nativeElement.close();
        this.measureToolsWindowRef.nativeElement.close();
        this.routingWindowRef.nativeElement.close();
        this.drawToolWindow.nativeElement.close();
        this.calloutToolWindowRef.nativeElement.close();
        this.shareLayerWindowRef.nativeElement.close();
        this.unshareLayerWindowRef.nativeElement.close();
        this.systemMessagesWindowRef.nativeElement.close();
        this.layerCatalogWindowRef.nativeElement.close();
        this.mapCatalogWindowRef.nativeElement.close();
        this.mapMergeWindowRef.nativeElement.close();
        this.aboutWindowRef.nativeElement.close();
        this.contactWindowRef.nativeElement.close();
        this.petlWindowRef.nativeElement.close();
        this.isleWindowRef.nativeElement.close();
        this.irowWindowRef.nativeElement.close();
    }
    resetMap() {
        this.onResetConfirm.emit();
        this.mapRef.MapService.resetMap();
        this.closeResetMap();
        this.router.navigate(['/']);
        this.searchRef.nativeElement.text = '';
    }
    generateCcList() {
        return __awaiter(this, void 0, void 0, function* () {
            const contacts = yield this.httpClient.get(`./static/contacts.json?cb=${new Date().valueOf().toString().slice(0, -7)}`).toPromise();
            this.contactList = contacts['ContactList'];
            this.centralOfficeEmail = contacts['CentralOfficeEmail'];
            for (const contactList of this.contactList) {
                const emailList = contactList.contactPersons.map(contact => contact.email).concat(this.centralOfficeEmail);
                for (const contact of contactList.contactPersons) {
                    contact.ccList = emailList.filter(email => email !== contact.email).join('; ');
                }
            }
        });
    }
    closeResetMap() {
        this.resetMapWindowRef.nativeElement.close();
    }
    deactivateIdentifyWhenOpen(value) {
        return this.disableIdentify.emit(value);
    }
    openLayerCatalog(event) {
        this.layerCatalogWindowRef.nativeElement.open();
        this.layerCatalogRef.nativeElement.active = true;
    }
    layerCatalogWindowOpenChange(e) {
        if (e.detail === false) {
            this.layerCatalogRef.nativeElement.active = false;
        }
    }
    layersAddedFromCatalog(e) {
        this.layerCatalogWindowRef.nativeElement.close();
    }
    openMapCatalog(event) {
        this.mapCatalogRef.nativeElement.mergeMaps = false;
        this.mapCatalogWindowRef.nativeElement.open();
    }
    closeMapCatalog(event) {
        this.mapCatalogWindowRef.nativeElement.close();
    }
    mapOpened(e) {
        this.onMapOpened.emit(e);
    }
    openAboutWindow() {
        this.aboutWindowRef.nativeElement.open();
    }
    openContactWindow() {
        this.contactWindowRef.nativeElement.open();
    }
    getRmsUrl(baseUrl) {
        let url = baseUrl;
        if (this.rms) {
            url += '?' + this.rms.params;
        }
        return url;
    }
    closeContactWindow() {
        this.contactWindowRef.nativeElement.close();
    }
    ngAfterContentInit() {
        calcite.dropdown();
    }
    onTabChanged(e) {
        const refs = {
            'Area': this.areaRef,
            'Coordinates': this.coordinatesRef,
            'Distance': this.distanceRef
        };
        for (const ref of Object.keys(refs)) {
            refs[ref].nativeElement.active = ref === e.detail.name;
        }
    }
    onWindowOpenChange(e) {
        if (!e.detail) {
            this.areaRef.nativeElement.active = false;
            this.distanceRef.nativeElement.active = false;
        }
    }
    logInOrOut(e) {
        e.preventDefault();
        if (!this.isLoggedIn && (this.pdauthUserId || (this.pdauthToken && this.pdauthToken.length && this.pdauthToken.length > 1))) {
            this.authRef.nativeElement.logout();
        }
        if (this.isLoggedIn) {
            this.authRef.nativeElement.logout();
        }
        else {
            this.authRef.nativeElement.login();
        }
    }
    showOrHideDisclaimer() {
        var userId = document.cookie.split('; ').map((item) => item.split('=')).find((item) => item[0] === 'pdauthUserId');
        this.pdauthToken = document.cookie.split('; ').map((item) => item.split('=')).find((item) => item[0] === 'PDAuth_token');
        if (userId && userId.length > 1) {
            this.pdauthUserId = decodeURIComponent(userId[1]);
        }
        else {
            this.pdauthUserId = '';
        }
        if (this.isLoggedIn && this.userPermissions && this.userPermissions.length > 0) {
            this.disclaimerWindowRef.nativeElement.close();
        }
        else {
            this.disclaimerWindowRef.nativeElement.open();
        }
    }
    openBookmarks(e) {
        e.preventDefault();
        this.bookmarksWindowRef.nativeElement.open();
    }
    openUserSettings(e) {
        e.preventDefault();
        this.userSettingsWindowRef.nativeElement.open();
    }
    openStreetView(e) {
        e.preventDefault();
        this.streetViewWindowRef.nativeElement.open();
    }
    openVideoLog(e) {
        e.preventDefault();
        this.videoLogWindowRef.nativeElement.open();
    }
    openCalloutTool(e) {
        e.preventDefault();
        this.calloutToolWindowRef.nativeElement.open();
    }
    openTIRe(e) {
        e.preventDefault();
        window.open(this.getRmsUrl(environmentMIQ.externalURLBase + '/tire'));
    }
    openIrow(e) {
        e.preventDefault();
        this.irowWindowRef.nativeElement.open();
    }
    openIsle(e) {
        e.preventDefault();
        this.isleWindowRef.nativeElement.open();
    }
    openSystemMessages(e) {
        e.preventDefault();
        this.systemMessagesWindowRef.nativeElement.open();
    }
    openPetl(e) {
        e.preventDefault();
        this.petlWindowRef.nativeElement.open();
    }
    closePetl(e) {
        e.preventDefault();
        this.petlWindowRef.nativeElement.close();
    }
    openMeasureTools(e) {
        e.preventDefault();
        this.measureToolsWindowRef.nativeElement.open();
        this.tabsRef.nativeElement.activateTab('Distance');
        this.distanceRef.nativeElement.active = true;
    }
    openRouting(e) {
        e.preventDefault();
        this.routingWindowRef.nativeElement.open();
    }
    openDrawTool(e) {
        e.preventDefault();
        this.drawToolWindow.nativeElement.open();
    }
    goToIsle(e) {
        e.preventDefault();
        window.open(this.getRmsUrl(environmentMIQ.internalURLBase + '/isle'));
    }
    goToIrow(e) {
        e.preventDefault();
        window.open(this.getRmsUrl(environmentMIQ.externalURLBase + '/irow'));
    }
    toggleSearchTips($event) {
        if (!this.searchTooltipsClickEventListenerAdded) {
            // Add an event listener to that any click will close the tooltips.
            document.addEventListener('click', (event) => {
                if (this.searchTips.visible && event.target && event.target.tagName && event.target.tagName !== 'MC-SEARCH') {
                    this.searchTips.visible = false;
                }
            });
            this.searchTooltipsClickEventListenerAdded = true;
        }
        this.searchTips.visible = !this.searchTips.visible;
        $event.stopPropagation();
    }
    tutorialVideo() {
        window.alert('Coming Soon');
    }
    searchResultSelected(event) {
        if (event.detail.type === 'map') {
            this.onMapOpened.emit(event.detail.result);
        }
    }
    mergeMap() {
        this.mapCatalogRef.nativeElement.mergeMaps = true;
        this.mapCatalogWindowRef.nativeElement.open();
    }
    // Disallow user to bypass user agreement for using Esc key
    keydown(e) {
        const escKey = 27;
        if (e.keyCode === escKey) {
            this.disclaimerWindowRef.nativeElement.open(NavMenuComponent, { disableClose: true });
        }
    }
    openShareLayerComponent(layerId) {
        this.shareLayerRef.nativeElement.layerId = null;
        this.shareLayerRef.nativeElement.layerId = layerId;
        this.shareLayerRef.nativeElement.includeEmail = true;
        this.shareLayerWindowRef.nativeElement.open();
    }
}
